const en = {
    chinese: "Chinese",
    english: "English",
    pageLoading: "Loading...",
    loaded: "All loaded",
    loadMore: "Slide up to load more",
    searchPlace: "Enter keywords to search",
    inputNumber: "Please enter number",
    release: "Pull down to refresh",
    releaseFinish: "Refreshed",
    releaseLoad: "Pull down to load more",
    releaseLoadFinish: "Loading completed",
    inputPlace: "Please enter",
    selectPlace: "Please select",
    formRequired: "is required",
    optional: "Optional",
    empty: "No data",
    reset: "Reset",
    giveUp: "Give up",
    confirm: "OK",
    cancel: "Cancel",
    close: "Close",
    gotIt: "Got it",
    exit: "Exit",
    pageStatusText: "Page does not exist",
    contactInfo: "Contact information",
    backHome: "Back to Home",
    cannotGetCustomerTips: "该群聊由微信账号创建，无法绑定客户和获取聊天记录（可直接粘贴文本进行识别）\n\n客户群符合条件：\n1.由企微账号创建\n2.群成员包含微信用户\n3.群成员人数≥3人",
    nav: {
        signIn: "Log in",
        expertDatabase: "Expert Database",
        demand: "Demand",
        newDemand: "New Demand",
        expertDetail: "Expert Details",
        newExpert: "New Expert",
    },
    expert: {
        detail: "Expert Detail"
    },
    demand: {
        add: "Add Demand",
        detail: "Demand Detail",
        pastetext: "Paste Text",
        aiAnalysis: "AI Recommendations",
    },
    status: {
        registering: "Active",
        registered: "Registered",
        playback: "Replay",
        finished: "Finished",
    },
    search: {
        searchKeyword: "Please enter keywords/company name/stock code/industry...",
        pastRecords: "Search history",
        hostSearch: " Hot search",
        hotTopics: "Hot discussion",
        relatedTopics: "Related discussion",
        relatedOwner: "Related camp Owner",
        name: "Search",
        corporation: "company",

        hotSearch: "User hot search",
        hotExpert: "Hot Expert",
        newExpert: "Newly signed expert",
        intentCount: "Interview times",
        intentAt: "Last interview",
    },
    btn: {
        expand: "Expand",
        close: "Close",
        recognize: "Recognize",
        pasteAndRecognize: "Paste and recognize",
    },
};

export default en;
